export const GRAPHQL_VARIABLES = {
  id: '5fbdb1a50c228f35dd575a37'
};

export const QUERY = `
  mutation leaveCompany($id: MongoID!){
    leaveCompany(companyId: $id){
        message
    }
}`;
